import styled from 'styled-components';

export const PostedInStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid hsl(0deg, 0%, 0%, 10%);
  margin-bottom: 16px;

  @media (max-width: 720px) {
    display: none;
  }
`;

export const PostedInImage = styled.img`
  width: 68px;
  height: 68px;
  border-radius: 50%;
  margin-right: 16px;
`;
